import ElementController from "../base-controllers/ElementController.js";
/** Require explicit confirmation of the visible submission conditions. */
class TermsAcceptance extends ElementController {
    constructor() {
        super(...arguments);
        this.update = () => {
            const submit = this.submit;
            if (submit)
                submit.disabled = !(this.acceptance?.checked ?? false);
        };
    }
    init() {
        this.update();
    }
    get acceptance() {
        return this.root.querySelector("[data-submission-acceptance]");
    }
    get submit() {
        return Array.from(this.root.ownerDocument.querySelectorAll("button[data-submission-submit]")).find((button) => button.form === this.root);
    }
}
TermsAcceptance.id = "TermsAcceptance";
TermsAcceptance.binds = {
    "[data-submission-acceptance]": [["change", "update"]],
};
export default TermsAcceptance;
//# sourceMappingURL=TermsAcceptance.js.map